import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbProductTabSpecifications } from '../../../models'

export const MB_PRODUCT_TAB_SPECIFICATION_NORMALIZER = new InjectionToken<Converter<any, MbProductTabSpecifications>>('MbProductTabSpecificationsNormalizer')
